import { useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../auth/useAuth";

/* Post-auth age gate (18+). Email signups attest via the form checkbox (recorded
   by the handle_new_user trigger), but OAuth signups bypass that form — this
   blocking gate catches anyone whose profile has no age_confirmed_at yet.

   Fail OPEN when the profile is unknown (offline / fetch failed): we only block
   when we positively know age_confirmed_at is null, so a connectivity blip never
   locks a confirmed user out of the app. */
export default function AgeGate({ children }) {
  const { profile, refreshProfile } = useAuth();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const needsGate = profile && profile.age_confirmed_at == null;
  if (!needsGate) return children;

  async function confirm() {
    setBusy(true);
    setErr(null);
    const { error } = await supabase.rpc("confirm_age");
    if (error) {
      setBusy(false);
      setErr("Couldn't save that — please try again.");
      return;
    }
    await refreshProfile();
    // refreshProfile flips needsGate false → children render; nothing else to do.
  }

  return (
    <div className="age-gate-backdrop" role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div className="auth-card">
        <h2 id="age-gate-title">One quick thing</h2>
        <p className="muted">
          Better Your Blackjack is a card-counting trainer intended for adults.
          Please confirm your age to continue.
        </p>

        {err && <div className="auth-error" role="alert">{err}</div>}

        <label className="age-check">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span>I am 18 years of age or older.</span>
        </label>

        <button
          className="sbtn primary wide"
          type="button"
          onClick={confirm}
          disabled={!checked || busy}
        >
          {busy ? "One moment…" : "Continue"}
        </button>
      </div>
    </div>
  );
}
